module.exports = {
  "zones": {
    "Asia/Pontianak": ["z", {
      "wallclock": 567993600000,
      "format": "WIB",
      "abbrev": "WIB",
      "offset": 25200000,
      "posix": 567964800000,
      "save": 0
    }, {
      "wallclock": -189388800000,
      "format": "WITA",
      "abbrev": "WITA",
      "offset": 28800000,
      "posix": -189415800000,
      "save": 0
    }, {
      "wallclock": -620784000000,
      "format": "+0730",
      "abbrev": "+0730",
      "offset": 27000000,
      "posix": -620812800000,
      "save": 0
    }, {
      "wallclock": -683856000000,
      "format": "+08",
      "abbrev": "+08",
      "offset": 28800000,
      "posix": -683883000000,
      "save": 0
    }, {
      "wallclock": -766022400000,
      "format": "+0730",
      "abbrev": "+0730",
      "offset": 27000000,
      "posix": -766054800000,
      "save": 0
    }, {
      "wallclock": -881193600000,
      "format": "+09",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": -881220600000,
      "save": 0
    }, {
      "wallclock": -1172880000000,
      "format": "+0730",
      "abbrev": "+0730",
      "offset": 27000000,
      "posix": -1172906240000,
      "save": 0
    }, {
      "wallclock": -1946160000000,
      "format": "PMT",
      "abbrev": "PMT",
      "offset": 26240000,
      "posix": -1946186240000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 26240000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};